import React from 'react';
import { NavLink, Link } from 'react-router-dom';

import LinkIcon from 'static/link-icon.svg';
import logo from 'static/logo.svg';
import { routesEnum } from '../../constants';
import './styles.scss'

const Header = () => {
  return (
    <div id="nav" className="nav">
      <ul>
        <Link className="brand-logo" to="/" >
          <li>
            <img alt="covid care logo" className="logo" src={logo} />
          </li>
        </Link>
        <div className="nav-buttons">
          { Object.keys(routesEnum).map(
            (link) => (
              <NavLink
                exact
                to={link}
                activeClassName="active"
              >
                <li> {routesEnum[link].title} </li>
              </NavLink>
            ))
          }
          <a target="_blank" rel="noopener noreferrer" href="https://delhicovidupdates.in/">
            <div>
              Blog <img className="link-icon" alt="link icon" src={LinkIcon} />
            </div>
          </a>
        </div>
      </ul>
    </div>
  );
};

export default Header;
